var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00272D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_12_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Black_12_",
    transform: "translate(-300.000000, -204.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line-1_4_",
    transform: "translate(200.000000, 200.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Twitter_2_",
    className: "st0",
    d: "M149,13.7c-1.8,0.8-3.7,1.3-5.7,1.6c2-1.2,3.6-3.2,4.3-5.6 c-1.9,1.2-4,2-6.3,2.4c-1.8-2-4.4-3.2-7.2-3.2c-5.4,0-9.8,4.5-9.8,10.1c0,0.8,0.1,1.6,0.3,2.3c-8.2-0.4-15.4-4.4-20.3-10.6 c-0.8,1.5-1.3,3.2-1.3,5.1c0,3.5,1.7,6.6,4.4,8.4c-1.6,0-3.1-0.5-4.5-1.3v0.1c0,4.9,3.4,9,7.9,9.9c-0.8,0.2-1.7,0.4-2.6,0.4 c-0.6,0-1.3-0.1-1.9-0.2c1.3,4,4.9,6.9,9.2,7c-3.4,2.7-7.6,4.3-12.2,4.3c-0.8,0-1.6,0-2.3-0.1c4.4,2.9,9.5,4.5,15.1,4.5 c18.1,0,28-15.4,28-28.7c0-0.4,0-0.9,0-1.3C146,17.5,147.7,15.8,149,13.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.adbf9633084da74c02f5ed891ab9fe4c.svg";
export { ForwardRef as ReactComponent };